import { Controller } from "@hotwired/stimulus"

/**
 * Newsletter slot: updates the preview turbo-frame when the nested
 * selection-receiver dispatches "changed".
 *
 * The turbo-frame fetches /bodies/:id, and Turbo extracts the matching
 * frame from the full page response (with layout). No special format needed.
 *
 * Targets:
 *   preview – the <turbo-frame> element to update
 */
export default class extends Controller {
  static targets = ["preview"]

  updatePreview(event) {
    const bodyId = event.detail.meta?.bodyId;
    if (!bodyId || !this.hasPreviewTarget) return;

    // Override hidden field: newsletter stores body_id, not content_id
    const field = this.element.querySelector('[data-selection-receiver-target="field"]');
    if (field) field.value = String(bodyId);

    this.previewTarget.id = `preview_body_${bodyId}`;
    this.previewTarget.src = `/bodies/${bodyId}`;
  }
}
